/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Socials_Items1Inputs */

const vi_sitesettings_socials_items1 = /** @type {(inputs: Sitesettings_Socials_Items1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mạng xã hội`)
};

/**

* @param {Sitesettings_Socials_Items1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_socials_items1 = /** @type {((inputs?: Sitesettings_Socials_Items1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Socials_Items1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_socials_items1(inputs)
});
export { sitesettings_socials_items1 as "siteSettings_socials_items" }